const mobileBreakPoint = getComputedStyle(document.body).getPropertyValue('--sm-min-plus-1');

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  connectedCallback() {
    if (this.dataset.qtyDelegated === 'true') return;
    this.dataset.qtyDelegated = 'true';
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    if (this.closest('cart-drawer')) return;

    const button = event.target.closest('.quantity__button');
    if (!button) return;

    this.input = this.querySelector('input');
    if (!this.input) return;

    event.preventDefault();
    const previousValue = this.input.value;

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue === this.input.value) return;

    const cartItems = this.closest('cart-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function' && this.input.dataset.index) {
      cartItems.updateQuantity(
        this.input.dataset.index,
        this.input.value,
        'updates[]',
        this.input.dataset.key
      );
      return;
    }

    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

// Helper function to find header section - works with both regular sections and section groups
// Made available globally for use in other scripts
window.findHeaderSection = function() {
  // Try the old ID format first
  let header = document.getElementById('shopify-section-header');
  if (header) return header;
  
  // Try to find section group header (format: shopify-section-{group-name}-{section-name})
  const allSections = document.querySelectorAll('[id^="shopify-section-"]');
  for (let section of allSections) {
    if (section.id.includes('header') && section.querySelector('.header, header-drawer')) {
      return section;
    }
  }
  
  // Fallback: find section containing header-drawer or .header class
  const headerDrawer = document.querySelector('header-drawer');
  if (headerDrawer) {
    const section = headerDrawer.closest('[id^="shopify-section-"]');
    if (section) return section;
  }
  
  const headerElement = document.querySelector('.header');
  if (headerElement) {
    const section = headerElement.closest('[id^="shopify-section-"]');
    if (section) return section;
  }
  
  return null;
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(summaryElement);
      } else {
        // Don't prevent default - let the details element open naturally
        // Then open the menu drawer after a brief delay to ensure open attribute is set
        setTimeout(() => {
          this.openMenuDrawer(summaryElement);
        }, 0);
      }
    } else {

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    // Ensure the details element has the open attribute first
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
    
    this.header = this.header || window.findHeaderSection();
    if (!this.header) {
      console.error('Header section not found');
      // Fallback: try to find header-wrapper or header element directly
      const headerWrapper = this.closest('.header-wrapper');
      if (headerWrapper) {
        const headerElement = headerWrapper.querySelector('.header');
        if (headerElement) {
          const headerBottom = parseInt(headerElement.getBoundingClientRect().bottom);
          document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
        }
      }
    } else {
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      
      // Calculate and set the header bottom position
      const headerBottom = parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset);
      // Ensure we have a valid value (at least the header height)
      const validBottom = headerBottom > 0 ? headerBottom : this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-bottom-position', `${validBottom}px`);
    }

    // Use double requestAnimationFrame to ensure the open attribute and CSS are fully processed
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      if (event.target.classList.contains('js-close')) this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    const product = this.dataset.product;
    if (product) {
      this.renderContents(product);
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }

  

  renderContents(product) {
    this.fetchQuickView(product);
  }

  fetchQuickView(product) {
    const productQuickView = `${routes.root_url}products/${product}/?section_id=quickview-product`;
    fetch(productQuickView)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML, product);
      })
      .catch(e => {
        this.renderPreview(e, product);
      });
  }

  renderPreview(sectionInnerHTML, product) {
    const drawer = document.querySelector(`#quickview-product-${product}`);
    drawer.innerHTML = sectionInnerHTML.innerHTML;




    //document.body.appendChild(sectionInnerHTML.querySelector('#quickview-product'));


  }



}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.slider.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.thumbnailButton = this.querySelectorAll('button[name="thumbnail]');
    this.thumbnailWrap = this.querySelector('.slider-thumbnails ol');
    this.dotButton = this.querySelectorAll('button[name="dot]');
    this.dotWrap = this.querySelector('.slider-dots ol');

    //if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.thumbnailWrap) {
      this.thumbnailWrap.addEventListener('click', this.onThumbnailClick.bind(this));
    }
    if (this.dotWrap) {
      this.dotWrap.addEventListener('click', this.onDotClick.bind(this));
    }
    this.slider.addEventListener('mousedown', this.startDragging.bind(this));
    this.slider.addEventListener('mouseup', this.stopDragging.bind(this));
    this.slider.addEventListener('mouseleave', this.stopDragging.bind(this));
    this.slider.addEventListener('mousemove', this.mouseMove.bind(this));
    this.mouseDown = false;
    this.oldx;
    this.current = 1;
  }

  


  startDragging = function (e) {
    this.mouseDown = true;
    this.oldx = e.pageX;
  }

  stopDragging = function (e) {
    this.mouseDown = false;
  }

  mouseMove = function (e) {
    e.preventDefault();
    if(!this.mouseDown) { return; }
    
    if (e.pageX < this.oldx) {
      var slideScrollPosition = this.slider.scrollLeft + this.sliderItems[0].clientWidth;
    } else if (e.pageX > this.oldx) {
      var slideScrollPosition = this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    }

    this.oldx = e.pageX;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.sliderItems.forEach(function(element, index) {
			element.style.order = index;
		});
    this.update();
    
  }

  update() {
    //if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.nextButton) {
    
      if (this.currentPage === 1) {
        this.prevButton.dataset.loop = 'start';
      } else {
        this.prevButton.removeAttribute('data-loop');
      }
    
      if (this.currentPage === this.totalPages) {
        this.nextButton.dataset.loop = 'end';
      } else {
        this.nextButton.removeAttribute('data-loop');
      }
      
      if (this.pageCount || this.pageTotal) {
        this.pageCount.textContent = this.currentPage;
        this.pageTotal.textContent = this.totalPages;
      }
    }

    if (this.dotWrap) {
      const dots = this.dotWrap.querySelectorAll('li');
      this.activeSlide = this.currentPage - 1;
      dots.forEach(dot => {
        dot.classList.remove('active');
      });
      dots[this.activeSlide].classList.add('active');
    }

  }

  onButtonClick(event) {
    event.preventDefault();
    
    if (event.target.dataset.loop === 'start') {
      this.lastSlide = this.sliderItems.length - this.slidesPerPage;
      const slideScrollPosition = this.slider.scrollLeft + this.sliderItems[this.lastSlide].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    } else if (event.target.dataset.loop === 'end') {
      this.slider.scrollTo({
        left: 0
      });
    } else {
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }

  onDotClick(event) {
    event.preventDefault();
    var HAS_COMPUTED_STYLE = !!window.getComputedStyle;
    var getStyles = window.getComputedStyle || function () { };
    var isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    var getFloat = function(value) {
      value = parseFloat(value);
      return isNumber(value) ? value : 0
    };
    const slideToShow = event.target.dataset.dot;
    if (!HAS_COMPUTED_STYLE) {
      var slideWidth = this.sliderItems[0].clientWidth; 
    } else {
      var slideWidth = getFloat(window.getComputedStyle(this.sliderItems[0]).width);
    }
    const slideScrollPosition = slideWidth * (slideToShow -1);
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onThumbnailClick(event) {
    event.preventDefault();
    var HAS_COMPUTED_STYLE = !!window.getComputedStyle;
    var getStyles = window.getComputedStyle || function () { };
    var isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    var getFloat = function(value) {
      value = parseFloat(value);
      return isNumber(value) ? value : 0
    };
    const slideToShow = event.target.dataset.thumbnail;
    if (!HAS_COMPUTED_STYLE) {
      var slideWidth = this.sliderItems[0].clientWidth; 
    } else {
      var slideWidth = getFloat(window.getComputedStyle(this.sliderItems[0]).width);
    }
    const slideScrollPosition = slideWidth * (slideToShow -1);
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.setAvailability();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateWishlist();
      this.renderProductInfo(event);
    }
  }

  setAvailability() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const options = this.querySelectorAll('select').length;
    if (options === 1) {
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    addButton.dataset.pickVariant = 'true';
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateWishlist() {
    const variantId = this.currentVariant.id;
    //window.triggerSwymVariantEvent(variantId);
    //swat.initializeActionButtons(".product-form__buttons");
    function swymCallbackFn(swat) {
      // your API calls go here 
      // detect variant change event
      // Based on your theme code - this event detection may be different - this is only a SAMPLE implementation    document.addEventListener("variantChange", function(event) {
          window.triggerSwymVariantEvent(variantId);
          swat.initializeActionButtons(".product-form__buttons");/* parent container of the where the button is rendered */
  }
  if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  }

  updateQuantities() {
    
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo(event) {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const priceId = `price-${this.dataset.section}`;
        const availabilitiesId = `availabilities-${this.dataset.section}`;
        const inventoryId = `PopupModal-inventory`;
        const variantSelects = `variant-selects-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinationPrice = document.getElementById(priceId);
        const sourcePrice = html.getElementById(priceId);
        const destinationAvailabilities = document.getElementById(availabilitiesId);
        const sourceAvailabilities = html.getElementById(availabilitiesId);
        const destinationInventory = document.getElementById(inventoryId);
        const sourceInventory = html.getElementById(inventoryId);

        if (sourcePrice && destinationPrice) destinationPrice.innerHTML = sourcePrice.innerHTML;
        if (sourceAvailabilities && destinationAvailabilities) destinationAvailabilities.innerHTML = sourceAvailabilities.innerHTML;
        if (sourceInventory && destinationInventory) destinationInventory.innerHTML = sourceInventory.innerHTML;

        if (event.target.classList.contains('modal-variant-select')) {
          const destinationVariants = document.getElementById(variantSelects);
          const sourceVariants = html.getElementById(variantSelects);
          if (sourceVariants && destinationVariants) destinationVariants.innerHTML = sourceVariants.innerHTML;
        }

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        document.getElementById(`availabilities-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const emailButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('.klaviyo-bis-trigger');

    if (!addButton) return;
    if (!emailButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
      addButton.classList.add('hidden');
      emailButton.classList.remove('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      addButton.classList.remove('hidden');
      emailButton.classList.add('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick.bind(this));

    var observer = new MutationObserver(function(mutations) {
      if (document.contains(document.querySelector('.cc-banner'))) {
        document.documentElement.style.setProperty('--footer-offset', document.querySelector('.cc-banner').offsetHeight + "px");
           observer.disconnect();
       }
   });
   
   observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
   
    

  }

  connectedCallback() {
    this.header = window.findHeaderSection();
    
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

  connectedCallback() {
    this.categories = document.querySelector('#shopify-section-announcement-bar');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.form = window.findHeaderSection();
    


    this.createObserver();
  }

  onButtonClick(e) {
    e.preventDefault();
      this.index = document.querySelector('#shopify-section-announcement-bar');   
      const headerSection = window.findHeaderSection();
      if (headerSection) {
        location.href = "#";
        location.href = `#${headerSection.id}`;
      }
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.categories);
  }

  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (!this.preventReveal) {

      if (this.isInViewport(this.categories)) {
        requestAnimationFrame(this.hideForm.bind(this));
      } else {
        requestAnimationFrame(this.revealForm.bind(this));
      }
      
      
    } else {
      window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

    }
  }

  hideForm() {
    this.classList.add('hidden');

  }

  revealForm() {
    this.classList.remove('hidden');
  }

  reset() {
    this.classList.add('hidden');
  }

}

customElements.define('back-to-top-button', BackToTopButton);